import { useEffect, useState } from "react";

const useUserValidated = () => {
  const [isValidated, setIsValidated] = useState(false);
  const validationType = localStorage.getItem("validationType");
  const isValid = validationType === "bvn";

  const handleIsValidated = (state: boolean) =>
    sessionStorage.setItem("userValidated", JSON.stringify(state));

  useEffect(() => {
    const intervalId = setInterval(() => {
      const statusFromStorage =
        JSON.parse(sessionStorage.getItem("userValidated")) || false;
      setIsValidated(statusFromStorage);
    }, 1000);

    return () => {
      clearInterval(intervalId);
      sessionStorage.removeItem("userValidated");
    };
  }, []);
  return {
    isValidated: isValidated || isValid,
    handleIsValidated,
    validationType,
    isValid,
  };
};

export default useUserValidated;
